module.exports = __webpack_public_path__ + "media/images/ohap_quiz_off-384819169306c90bc5f0cd202ab6b6b0.png";